// Location content — drives the reusable LocationPage template (EN/FR/DE).

export const LOCATIONS = [
  {
    key: "ho-chi-minh-city",
    image:
      "https://images.unsplash.com/photo-1521019795854-14e15f600980?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    slug: {
      en: "dentist-ho-chi-minh-city",
      fr: "dentiste-ho-chi-minh-ville",
      de: "zahnarzt-ho-chi-minh-stadt",
    },
    name: { en: "Ho Chi Minh City", fr: "Hô Chi Minh-Ville", de: "Ho-Chi-Minh-Stadt" },
    tagline: {
      en: "Vietnam’s largest city and a common choice for international patients.",
      fr: "La plus grande ville du Vietnam, souvent choisie par les patients internationaux.",
      de: "Vietnams größte Stadt und eine häufige Wahl für internationale Patienten.",
    },
    metaTitle: {
      en: "Dentist in Ho Chi Minh City | Guide for International Patients",
      fr: "Dentiste à Hô Chi Minh-Ville | Guide pour patients internationaux",
      de: "Zahnarzt in Ho-Chi-Minh-Stadt | Ratgeber für internationale Patienten",
    },
    metaDesc: {
      en: "Considering a dentist in Ho Chi Minh City? Independent information for international patients on treatment, travel and what to check.",
      fr: "Vous envisagez un dentiste à Hô Chi Minh-Ville ? Informations indépendantes sur le traitement, le voyage et les points à vérifier.",
      de: "Zahnarzt in Ho-Chi-Minh-Stadt gesucht? Unabhängige Informationen zu Behandlung, Anreise und Prüfpunkten.",
    },
    intro: {
      en: [
        "Ho Chi Minh City (formerly Saigon) is Vietnam’s largest and most international city. It is a common choice for international patients because of its wide range of dental providers, international flight connections and English-speaking support at some clinics.",
        "As with any destination, standards vary between providers. We encourage patients to review each clinic’s licence, the dentist’s credentials and the treatment plan carefully.",
      ],
      fr: [
        "Hô Chi Minh-Ville (anciennement Saïgon) est la plus grande et la plus internationale des villes du Vietnam. Elle est souvent choisie par les patients internationaux pour son large choix de prestataires dentaires, ses liaisons aériennes et l’accueil en anglais dans certaines cliniques.",
        "Comme partout, les standards varient selon les prestataires. Nous encourageons les patients à examiner la licence de chaque clinique, les diplômes du dentiste et le plan de traitement.",
      ],
      de: [
        "Ho-Chi-Minh-Stadt (früher Saigon) ist Vietnams größte und internationalste Stadt. Sie ist eine häufige Wahl für internationale Patienten wegen des breiten Angebots an Anbietern, der Flugverbindungen und der englischsprachigen Betreuung in einigen Kliniken.",
        "Wie überall variieren die Standards je nach Anbieter. Wir empfehlen, Kliniklizenz, Qualifikationen des Zahnarztes und den Behandlungsplan sorgfältig zu prüfen.",
      ],
    },
    highlights: {
      en: [
        "International airport with wide flight connections",
        "A range of dental providers to consider",
        "English-speaking support at some clinics",
        "Plenty of accommodation and travel options",
      ],
      fr: [
        "Aéroport international avec de nombreuses liaisons",
        "Un éventail de prestataires dentaires à considérer",
        "Accueil en anglais dans certaines cliniques",
        "Nombreuses options d’hébergement et de voyage",
      ],
      de: [
        "Internationaler Flughafen mit vielen Verbindungen",
        "Eine Auswahl an Zahnanbietern zur Auswahl",
        "Englischsprachige Betreuung in einigen Kliniken",
        "Viele Unterkunfts- und Reiseoptionen",
      ],
    },
    sections: [
      {
        h: { en: "Dental treatment in Ho Chi Minh City", fr: "Soins dentaires à Hô Chi Minh-Ville", de: "Zahnbehandlung in Ho-Chi-Minh-Stadt" },
        body: {
          en: ["As Vietnam’s largest city, Ho Chi Minh City has the widest concentration of dental providers, including clinics used to treating international patients. This makes it a common starting point for complex work such as implants, All-on-4 and full smile makeovers, where a broader choice of providers and technology can be helpful. Availability and standards still vary between clinics, so compare providers carefully."],
          fr: ["Plus grande ville du Vietnam, Hô Chi Minh-Ville concentre le plus grand nombre de prestataires dentaires, dont des cliniques habituées aux patients internationaux. C’est souvent un point de départ pour des travaux complexes comme les implants, l’All-on-4 ou un relooking complet du sourire, où un plus grand choix de prestataires et de technologies peut aider. La disponibilité et les standards varient toutefois : comparez soigneusement."],
          de: ["Als größte Stadt Vietnams hat Ho-Chi-Minh-Stadt die höchste Dichte an Zahnanbietern, darunter Kliniken mit Erfahrung bei internationalen Patienten. Sie ist oft Ausgangspunkt für komplexe Arbeiten wie Implantate, All-on-4 oder ein komplettes Smile Makeover, wo eine größere Auswahl an Anbietern und Technik hilfreich sein kann. Verfügbarkeit und Standards variieren jedoch — vergleichen Sie sorgfältig."],
        },
      },
      {
        h: { en: "Getting around and patient considerations", fr: "Se déplacer et points pratiques", de: "Fortbewegung und Hinweise für Patienten" },
        body: {
          en: ["Tan Son Nhat International Airport connects the city to many countries, and taxis and ride-hailing apps make getting to appointments straightforward. If your treatment is staged — as implants often are — factor in comfortable accommodation and time between visits. Confirm your treatment plan, costs and aftercare in writing before you travel."],
          fr: ["L’aéroport international de Tân Son Nhât relie la ville à de nombreux pays, et taxis et applications de VTC facilitent les trajets vers les rendez-vous. Si votre traitement est échelonné — comme souvent pour les implants — prévoyez un hébergement confortable et du temps entre les visites. Confirmez plan de traitement, coûts et suivi par écrit avant de partir."],
          de: ["Der internationale Flughafen Tan Son Nhat verbindet die Stadt mit vielen Ländern, und Taxis sowie Fahrdienst-Apps erleichtern den Weg zu Terminen. Ist Ihre Behandlung mehrstufig — wie bei Implantaten oft — planen Sie bequeme Unterkunft und Zeit zwischen den Besuchen ein. Bestätigen Sie Behandlungsplan, Kosten und Nachsorge schriftlich vor der Reise."],
        },
      },
    ],
  },
  {
    key: "da-nang",
    image:
      "https://images.unsplash.com/photo-1723142282970-1fd415eec1ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    slug: {
      en: "dentist-da-nang",
      fr: "dentiste-da-nang",
      de: "zahnarzt-da-nang",
    },
    name: { en: "Da Nang", fr: "Da Nang", de: "Da Nang" },
    tagline: {
      en: "A coastal city popular with visitors and patients alike.",
      fr: "Une ville côtière prisée des visiteurs comme des patients.",
      de: "Eine Küstenstadt, beliebt bei Besuchern und Patienten.",
    },
    metaTitle: {
      en: "Dentist in Da Nang | Guide for International Patients",
      fr: "Dentiste à Da Nang | Guide pour patients internationaux",
      de: "Zahnarzt in Da Nang | Ratgeber für internationale Patienten",
    },
    metaDesc: {
      en: "Thinking about a dentist in Da Nang? Independent information for international patients on dental care and combining treatment with a coastal stay.",
      fr: "Vous pensez à un dentiste à Da Nang ? Informations indépendantes pour associer soins dentaires et séjour balnéaire.",
      de: "Zahnarzt in Da Nang? Unabhängige Informationen für internationale Patienten und die Kombination mit einem Küstenaufenthalt.",
    },
    intro: {
      en: [
        "Da Nang is a coastal city in central Vietnam known for its beaches and relaxed pace. Some international patients consider Da Nang because it allows treatment to be combined with recovery time by the sea.",
        "Provider availability is more limited than in the largest cities, so it is worth confirming that a clinic offers your specific treatment and has relevant experience.",
      ],
      fr: [
        "Da Nang est une ville côtière du centre du Vietnam, connue pour ses plages et son rythme paisible. Certains patients internationaux la choisissent pour associer traitement et récupération en bord de mer.",
        "L’offre de prestataires y est plus limitée que dans les grandes villes ; vérifiez qu’une clinique propose votre traitement et possède l’expérience nécessaire.",
      ],
      de: [
        "Da Nang ist eine Küstenstadt in Zentralvietnam, bekannt für Strände und entspanntes Tempo. Manche internationalen Patienten wählen Da Nang, um Behandlung und Erholung am Meer zu verbinden.",
        "Das Anbieterangebot ist begrenzter als in den größten Städten; prüfen Sie, ob eine Klinik Ihre Behandlung anbietet und über Erfahrung verfügt.",
      ],
    },
    highlights: {
      en: [
        "Relaxed coastal setting for recovery",
        "International airport",
        "Combine treatment with a beach stay",
        "Confirm treatment availability in advance",
      ],
      fr: [
        "Cadre côtier paisible pour la récupération",
        "Aéroport international",
        "Associer traitement et séjour balnéaire",
        "Confirmer la disponibilité du traitement à l’avance",
      ],
      de: [
        "Entspanntes Küstenambiente zur Erholung",
        "Internationaler Flughafen",
        "Behandlung mit Strandaufenthalt verbinden",
        "Verfügbarkeit der Behandlung vorab bestätigen",
      ],
    },
    sections: [
      {
        h: { en: "Dental treatment in Da Nang", fr: "Soins dentaires à Da Nang", de: "Zahnbehandlung in Da Nang" },
        body: {
          en: ["Da Nang appeals to patients who want to pair treatment with recovery in a calmer, coastal setting. The choice of providers is more limited than in Ho Chi Minh City or Hanoi, so it is especially important to confirm that a clinic offers your specific treatment — for example implants or veneers — and has relevant experience before you plan your trip."],
          fr: ["Da Nang séduit les patients qui souhaitent associer traitement et récupération dans un cadre côtier plus calme. L’offre de prestataires y est plus limitée qu’à Hô Chi Minh-Ville ou Hanoï : il est donc essentiel de confirmer qu’une clinique propose votre traitement précis — implants ou facettes par exemple — et possède l’expérience nécessaire avant d’organiser votre voyage."],
          de: ["Da Nang spricht Patienten an, die Behandlung und Erholung in ruhiger Küstenlage verbinden möchten. Das Anbieterangebot ist geringer als in Ho-Chi-Minh-Stadt oder Hanoi. Bestätigen Sie daher unbedingt vorab, dass eine Klinik Ihre konkrete Behandlung anbietet — etwa Implantate oder Veneers — und über passende Erfahrung verfügt."],
        },
      },
      {
        h: { en: "Travel and treatment planning in Da Nang", fr: "Voyage et planification à Da Nang", de: "Reise- und Behandlungsplanung in Da Nang" },
        body: {
          en: ["Da Nang International Airport serves regional and some international routes, and the city is a gateway to Hoi An and central Vietnam. For staged treatments such as implants, the relaxed pace can suit recovery — but plan the timing carefully, and share your dental records and X-rays in advance so options can be reviewed before you arrive."],
          fr: ["L’aéroport international de Da Nang dessert des lignes régionales et quelques lignes internationales, et la ville est une porte d’entrée vers Hôi An et le centre du Vietnam. Pour des traitements échelonnés comme les implants, le rythme paisible peut convenir à la récupération — mais planifiez soigneusement le calendrier et transmettez vos dossiers et radiographies à l’avance pour étudier les options avant votre arrivée."],
          de: ["Der internationale Flughafen Da Nang bedient regionale und einige internationale Strecken; die Stadt ist Tor zu Hoi An und Zentralvietnam. Für mehrstufige Behandlungen wie Implantate kann das ruhige Tempo zur Erholung passen — planen Sie den Zeitplan sorgfältig und senden Sie Unterlagen und Röntgenbilder vorab, damit Optionen vor der Ankunft geprüft werden können."],
        },
      },
    ],
  },
  {
    key: "hanoi",
    image:
      "https://images.unsplash.com/photo-1616486410185-81af2d32a2af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    slug: {
      en: "dentist-hanoi",
      fr: "dentiste-hanoi",
      de: "zahnarzt-hanoi",
    },
    name: { en: "Hanoi", fr: "Hanoï", de: "Hanoi" },
    tagline: {
      en: "Vietnam’s capital, rich in history and culture.",
      fr: "La capitale du Vietnam, riche en histoire et en culture.",
      de: "Vietnams Hauptstadt, reich an Geschichte und Kultur.",
    },
    metaTitle: {
      en: "Dentist in Hanoi | Guide for International Patients",
      fr: "Dentiste à Hanoï | Guide pour patients internationaux",
      de: "Zahnarzt in Hanoi | Ratgeber für internationale Patienten",
    },
    metaDesc: {
      en: "Considering a dentist in Hanoi? Independent information for international patients on dental care in Vietnam’s capital.",
      fr: "Vous envisagez un dentiste à Hanoï ? Informations indépendantes sur les soins dentaires dans la capitale du Vietnam.",
      de: "Zahnarzt in Hanoi? Unabhängige Informationen zu Zahnbehandlungen in Vietnams Hauptstadt.",
    },
    intro: {
      en: [
        "Hanoi is Vietnam’s capital and a major cultural centre in the north of the country. It offers a range of dental providers and good international travel connections.",
        "As with every location, we encourage patients to verify each clinic’s credentials and treatment plan before committing.",
      ],
      fr: [
        "Hanoï est la capitale du Vietnam et un grand centre culturel du nord du pays. Elle propose un éventail de prestataires dentaires et de bonnes liaisons internationales.",
        "Comme pour chaque destination, nous encourageons les patients à vérifier les diplômes de chaque clinique et le plan de traitement avant de s’engager.",
      ],
      de: [
        "Hanoi ist Vietnams Hauptstadt und ein bedeutendes Kulturzentrum im Norden des Landes. Es bietet eine Auswahl an Anbietern und gute internationale Verbindungen.",
        "Wie bei jedem Standort empfehlen wir, Qualifikationen jeder Klinik und den Behandlungsplan vor der Entscheidung zu prüfen.",
      ],
    },
    highlights: {
      en: [
        "Capital city with cultural attractions",
        "International airport",
        "A range of dental providers",
        "Good base for exploring northern Vietnam",
      ],
      fr: [
        "Capitale aux nombreuses attractions culturelles",
        "Aéroport international",
        "Un éventail de prestataires dentaires",
        "Bon point de départ pour le nord du Vietnam",
      ],
      de: [
        "Hauptstadt mit kulturellen Sehenswürdigkeiten",
        "Internationaler Flughafen",
        "Eine Auswahl an Zahnanbietern",
        "Guter Ausgangspunkt für Nordvietnam",
      ],
    },
    sections: [
      {
        h: { en: "Dental treatment in Hanoi", fr: "Soins dentaires à Hanoï", de: "Zahnbehandlung in Hanoi" },
        body: {
          en: ["As the capital, Hanoi offers a range of dental providers across the city, including clinics that treat international patients. It can be a practical choice for those already visiting northern Vietnam or combining treatment with cultural travel. As with any location, confirm the clinic’s credentials and your written treatment plan before committing."],
          fr: ["Capitale du pays, Hanoï propose un éventail de prestataires dentaires à travers la ville, dont des cliniques qui reçoivent des patients internationaux. C’est un choix pratique pour ceux qui visitent déjà le nord du Vietnam ou associent traitement et voyage culturel. Comme partout, vérifiez les diplômes de la clinique et votre plan de traitement écrit avant de vous engager."],
          de: ["Als Hauptstadt bietet Hanoi stadtweit eine Auswahl an Zahnanbietern, darunter Kliniken für internationale Patienten. Für Reisende im Norden Vietnams oder bei einer Kombination aus Behandlung und Kulturreise kann es eine praktische Wahl sein. Prüfen Sie wie überall die Qualifikationen der Klinik und Ihren schriftlichen Behandlungsplan vor der Entscheidung."],
        },
      },
      {
        h: { en: "Getting around and planning treatment in Hanoi", fr: "Se déplacer et planifier à Hanoï", de: "Fortbewegung und Planung in Hanoi" },
        body: {
          en: ["Noi Bai International Airport links Hanoi to many international cities, and the compact centre makes travelling to appointments manageable. For multi-stage work such as implants, allow time between visits for healing and plan follow-up. Sending photos and X-rays ahead of time lets possible options be reviewed before you travel — though only an in-person exam can confirm a plan."],
          fr: ["L’aéroport international de Nôi Bài relie Hanoï à de nombreuses villes internationales, et le centre compact facilite les trajets vers les rendez-vous. Pour un traitement en plusieurs étapes comme les implants, prévoyez du temps entre les visites pour la cicatrisation et le suivi. Envoyer photos et radiographies à l’avance permet d’étudier les options avant le départ — mais seul un examen en personne peut confirmer un plan."],
          de: ["Der internationale Flughafen Noi Bai verbindet Hanoi mit vielen Städten, und das kompakte Zentrum erleichtert den Weg zu Terminen. Bei mehrstufigen Arbeiten wie Implantaten planen Sie Zeit zwischen den Besuchen für Heilung und Nachsorge ein. Fotos und Röntgenbilder vorab ermöglichen eine Vorabprüfung der Optionen — bestätigen kann einen Plan aber nur eine persönliche Untersuchung."],
        },
      },
    ],
  },
];

export const getLocation = (key) => LOCATIONS.find((l) => l.key === key);
export const getLocationBySlug = (slug, lang) =>
  LOCATIONS.find((l) => l.slug[lang] === slug || Object.values(l.slug).includes(slug));
